<div *ngIf="show" class="fixed inset-0 z-40 bg-black/50 transition-opacity" (click)="cancel()"></div>
<div *ngIf="show" class="fixed inset-0 z-50 flex items-center justify-center p-4">
  <div class="bg-white rounded-xl shadow-2xl w-[50vw] 2xl:w-[35vw]" (click)="$event.stopPropagation()">
    <div class="flex justify-between items-center p-5 border-b border-gray-200">
      <h3 class="text-lg font-bold text-gray-800">{{title | translate }}</h3>
      <button type="button" (click)="cancel()" class="text-gray-400 hover:text-gray-600 transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6 6 18" />
          <path d="m6 6 12 12" />
        </svg>
      </button>
    </div>
    <div class="p-6">
      <form (ngSubmit)="save()" autocomplete="off">
        <div class="space-y-5 py-2 px-1">
          <ng-container *ngFor="let col of columns">
            <div class="flex items-center gap-4">
              <label class="w-48 tracking-wide"><span *ngIf="col.requierd" class="text-red-500">*</span> {{
                (col.captionName
                || col.label) | translate }}</label>
              <ng-container *ngIf="col.type === 'number'; else normalInput">
                <input type="text"
                  class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none transition-all text-right"
                  [class.bg-gray-100]="col.disabled" [class.cursor-not-allowed]="col.disabled"
                  [class.focus:border-indigo-500]="!col.disabled" [class.focus:ring-2]="!col.disabled"
                  [class.focus:ring-indigo-100]="!col.disabled" [value]="formatNumber(editedData[col.key])"
                  (input)="onNumberInput(col.key, $event)" [name]="col.key" [disabled]="col.disabled"
                  [style.height]="col.height ? (col.height + (isNaN(col.height) ? '' : 'px')) : null"
                  autocomplete="off" />
              </ng-container>
              <ng-template #normalInput>
                <ng-container *ngIf="col.type === 'select'; else textInput">
                  <select
                    class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none transition-all appearance-none bg-white"
                    [class.bg-gray-100]="col.disabled" [class.cursor-not-allowed]="col.disabled"
                    [class.focus:border-indigo-500]="!col.disabled" [class.focus:ring-2]="!col.disabled"
                    [class.focus:ring-indigo-100]="!col.disabled" [(ngModel)]="editedData[col.key]" [name]="col.key"
                    [disabled]="col.disabled">
                    <option *ngFor="let opt of col.options" [value]="opt.value">{{ opt.label | translate }}</option>
                  </select>
                </ng-container>
                <ng-template #textInput>
                  @if(col.key == 'customerNo'){
                  <input [type]="col.type === 'number' ? 'number' : 'text'"
                    class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none transition-all"
                    [class.bg-gray-100]="col.disabled" [class.cursor-not-allowed]="col.disabled"
                    [class.focus:border-indigo-500]="!col.disabled" [class.focus:ring-2]="!col.disabled"
                    [class.focus:ring-indigo-100]="!col.disabled" [value]="editedData[col.key].slice(-13)"
                    [name]="col.key" [disabled]="col.disabled"
                    [style.height]="col.height ? (col.height + (isNaN(col.height) ? '' : 'px')) : null" />
                  }
                  @else {
                  <input [type]="col.type === 'number' ? 'number' : 'text'" [maxLength]="col.maxLength"
                    class="flex-1 border border-gray-300 px-4 py-2.5 rounded-lg outline-none transition-all"
                    [class.bg-gray-100]="col.disabled" [class.cursor-not-allowed]="col.disabled"
                    [class.focus:border-indigo-500]="!col.disabled" [class.focus:ring-2]="!col.disabled"
                    [class.focus:ring-indigo-100]="!col.disabled" [(ngModel)]="editedData[col.key]" [name]="col.key"
                    [disabled]="col.disabled"
                    [style.height]="col.height ? (col.height + (isNaN(col.height) ? '' : 'px')) : null" />
                  }
                </ng-template>
              </ng-template>
            </div>
          </ng-container>
        </div>
        <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-xl mt-6 -mx-6 -mb-6">
          <div class="flex justify-center w-full gap-3">
            <button type="button" (click)="cancel()"
              class="px-6 py-2.5 bg-white border border-gray-300 text-gray-700 font-bold rounded-lg hover:bg-gray-50 transition-colors">{{'SYSMESER0010'
              | translate}}</button>
            <button type="submit"
              class="px-8 py-2.5 bg-indigo-600 text-white font-bold rounded-lg hover:bg-indigo-700 shadow-sm transition-colors">{{'CUSTMSTR0007'
              | translate}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>